// extracted by mini-css-extract-plugin
export default {"color1":"#395b64","color2":"#a5c9ca","color3":"#e7f6f2","surfaceColor":"#121212","main-animation-length":".75s"};